export const getFeaturedItems = state => state.featuredItems.featuredItems

export const getFeaturedItemPollIntervalId = state => state.featuredItems.featuredItems.intervalId

export const getFeaturedItemPollingProgress = state => state.featuredItems.featuredItems.pollingProgress

export const getNewFeaturedItem = state => state.featuredItems.newFeaturedItem

export const getUpdateFeaturedItem = state => state.featuredItems.updateFeaturedItem

export const getDeleteFeaturedItem = state => state.featuredItems.deleteFeaturedItem

export const getIsDeletingAllFeaturedItems = state => state.featuredItems.featuredItems.isDeletingAllFeaturedItems

export const getHasErrorDeletingAllFeaturedItems = state => Boolean(
  state.featuredItems.featuredItems.errorDeletingAllFeaturedItems
)
